// extracted by mini-css-extract-plugin
export default {"lesson-page":"styles_lesson-page__CGUgQ"};